module.exports = __webpack_public_path__ + "icomoon.68416ba9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/fonts/icomoon/icomoon.woff
// module id = 1325
// module chunks = 1